<div class="container" fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="center center">
  <div class="header" *ngIf="!hideButtons">
    {{ heading }}
  </div>
  <div fxLayout="row">
    <ng-content></ng-content>
  </div>
  <div [fxShow]="!uploading && !hideButtons" fxLayout="row" fxLayoutGap="15px">
    <button mat-flat-button color="primary" fxLayout="row" fxLayoutAlign="space-between center" (click)="file.click()">
      <mat-icon>add</mat-icon> Load
      <input #file type="file" (change)="upload(file.files)" style="display:none;" accept=".png"/>
    </button>

    <button [disabled]="!assetLoaded" mat-flat-button color="accent" fxLayout="row" fxLayoutAlign="space-between center"
      (click)="saveClick()">
      <mat-icon>done</mat-icon> Save
    </button>
  </div>
  <div *ngIf="uploading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
